import ForgotPass from "../images/login-images/forgot-password-frent-img.jpg"
import profile from "../images/avatars/avatar-2.png"
import BgLogin from "../images/background-login.png"
import AdminLogo from "../images/logo-admin.png"
import Playstore from "../images/playstore.png"
import AppStore from "../images/app_store.png"
import NewLogo from "../images/new-logo.png"
import favicon from "../images/favicon.png"
import Lock from "../images/icons/lock.png"
import logo from "../images/logo-icon.png"
import MainLogo from "../images/logo.png"
import Car from "../images/car.png"

const Images = {
    logo,
    Lock,
    Car,
    BgLogin,
    NewLogo,
    profile,
    favicon,
    MainLogo,
    AppStore,
    AdminLogo,
    Playstore,
    ForgotPass,
}

export default Images